import React, { Component } from "react";
import MainLayout from "../../Components/Layouts/MainLayout";
import Toastr from "../../Utils/Toastr";
import UsersDataService from "../../Components/Services/Users.Service";

export default class UserDashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.getDashBoardData = this.getDashBoardData.bind(this);
  }

  componentDidMount() {
    this.getDashBoardData();
  }

  getDashBoardData = async() => {
    this.setState({ loading: true });
    let dateStr = new Date().getTime();
    var dt = new Date(dateStr);
    dt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    let today = dt.getFullYear() + "-" + (1 + dt.getMonth()).toString().padStart(2, '0') + "-" + dt.getDate().toString().padStart(2, '0')

    dt = new Date(dt.getTime() - (dt.getDay() > 0 ? (dt.getDay() - 1) * 1000 * 60 * 60 * 24 : 6 * 1000 * 60 * 60 * 24));
    let start = dt;
    let end = new Date(dt.getTime() + 1000 * 60 * 60 * 24 * 7 - 1)
    let weekStart = start.getFullYear() + "-" + (1 + start.getMonth()).toString().padStart(2, '0') + "-" + start.getDate().toString().padStart(2, '0')
    let weekEnd = end.getFullYear() + "-" + (1 + end.getMonth()).toString().padStart(2, '0') + "-" + end.getDate().toString().padStart(2, '0')

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    dateStr = new Date();
    let monthName = monthNames[dateStr.getMonth()];
    var date = new Date(Date.parse(monthName + 1, new Date().getFullYear()));
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getDate();
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    var month = new Date(Date.parse(monthName + 1, new Date().getFullYear())).getMonth()+1;
    var year = new Date().getFullYear();

    var data = {
      today: today,
      weekStart: weekStart,
      weekEnd: weekEnd,
      monthStart: year + "-" + month.toString().padStart(2, '0') + "-" + firstDay.toString().padStart(2, '0'),
      monthEnd: year + "-" + month.toString().padStart(2, '0') + "-" + lastDay.toString().padStart(2, '0'),
      yearStart:  year + "-" + '01' + "-" + '01',
      yearEnd: year + "-" + '12' + "-" + '31',
      unitId: localStorage.getItem('unitid'),
    };
    await UsersDataService.getDashBoardData(data)
      .then(response => {
        response.data.map((token, index) => {
          response.data[index].countAllThisYear = token.countAllThisYear.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumAllThisYear = token.sumAllThisYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countAllThisMonth = token.countAllThisMonth.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumAllThisMonth = token.sumAllThisMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countAllThisWeek = token.countAllThisWeek.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumAllThisWeek = token.sumAllThisWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countAllToday = token.countAllToday.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumAllToday = token.sumAllToday.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
		
          response.data[index].countPendingThisYear = token.countPendingThisYear.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumPendingThisYear = token.sumPendingThisYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countPendingThisMonth = token.countPendingThisMonth.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumPendingThisMonth = token.sumPendingThisMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countPendingThisWeek = token.countPendingThisWeek.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumPendingThisWeek = token.sumPendingThisWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countPendingToday = token.countPendingToday.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumPendingToday = token.sumPendingToday.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
		
          response.data[index].countApprovedThisYear = token.countApprovedThisYear.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumApprovedThisYear = token.sumApprovedThisYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countApprovedThisMonth = token.countApprovedThisMonth.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumApprovedThisMonth = token.sumApprovedThisMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countApprovedThisWeek = token.countApprovedThisWeek.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumApprovedThisWeek = token.sumApprovedThisWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countApprovedToday = token.countApprovedToday.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumApprovedToday = token.sumApprovedToday.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
		
          response.data[index].countQueriedThisYear = token.countQueriedThisYear.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumQueriedThisYear = token.sumQueriedThisYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countQueriedToday = token.countQueriedToday.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumQueriedToday = token.sumQueriedToday.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countQueriedThisWeek = token.countQueriedThisWeek.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumQueriedThisWeek = token.sumQueriedThisWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].countQueriedThisMonth = token.countQueriedThisMonth.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          response.data[index].sumQueriedThisMonth = token.sumQueriedThisMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')

        })
        this.setState({list: response.data})
      })
      .catch(() => {
        Toastr(
          "error",
          "Error fetching Dashboard Data"
        );
        this.setState({ loading: false });
      });
      
  };



  render() {
    const { list } = this.state;
    
        return (
          <MainLayout
            role="user"
            title={'Hello ' + localStorage.getItem('username')}
            subtitle="Here's how your unit is performing"
          >
          {list &&
            list.map(list => {
              return (
            <div className="row g-gs">
              <div className="col-lg-6 col-xxl-12">
                <div className="row g-gs">
                  <div className="col-lg-6 col-xxl-6">
                    <div className="card card-bordered">
                      <div className="card-inner">
                        <div className="card-title-group align-start mb-2">
                          <div className="card-title">
                            <h6 className="title">All Vouchers Received</h6>
                            <p></p>
                          </div>
                        </div>
                        <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
                          <div className="nk-sale-data-group flex-md-nowrap g-4">
                            <div className="nk-sale-data">
                              <span className="sub-title">Year To Date</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumAllThisYear}K ({list.countAllThisYear})
                              </span>
                            </div>
                            <div className="nk-sale-data">
                              <span className="sub-title">This Month</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumAllThisMonth}K ({list.countAllThisMonth})
                              </span>
                            </div>
                            <div className="nk-sale-data">
                              <span className="sub-title">This Week</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumAllThisWeek}K ({list.countAllThisWeek})
                              </span>
                            </div>
                            <div className="nk-sale-data">
                              <span className="sub-title">Today</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumAllToday}K ({list.countAllToday})
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-12 col-xxl-6">
                    <div className="card card-bordered">
                      <div className="card-inner">
                        <div className="card-title-group align-start mb-2">
                          <div className="card-title">
                            <h6 className="title">Approved Vouchers</h6>
                          </div>
                        </div>
                        <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
                          <div className="nk-sale-data-group flex-md-nowrap g-4">
                            <div className="nk-sale-data">
                              <span className="sub-title">Year To Date</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumApprovedThisYear}K ({list.countApprovedThisYear})
                              </span>
                            </div>
                            <div className="nk-sale-data">
                              <span className="sub-title">This Month</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumApprovedThisMonth}K ({list.countApprovedThisMonth})
                              </span>
                            </div>
                            <div className="nk-sale-data">
                              <span className="sub-title">This Week</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumApprovedThisWeek}K ({list.countApprovedThisWeek})
                              </span>
                            </div>
                            <div className="nk-sale-data">
                              <span className="sub-title">Today</span>
                              <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                              &#8358;{list.sumApprovedToday}K ({list.countApprovedToday})
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* .card */}
                  </div>
                  {/* .col */}
                  <div className="col-lg-6 col-xxl-12">
                    <div className="row g-gs">
                      <div className="col-sm-6 col-lg-12 col-xxl-6">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div className="card-title-group align-start mb-2">
                              <div className="card-title">
                                <h6 className="title">Queried Vouchers</h6>
                              </div>
                            </div>
                            <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
                              <div className="nk-sale-data-group flex-md-nowrap g-4">
                                <div className="nk-sale-data">
                                  <span className="sub-title">Year To Date</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumQueriedThisYear}K ({list.countQueriedThisYear})
                                  </span>
                                </div>
                                <div className="nk-sale-data">
                                  <span className="sub-title">This Month</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumQueriedThisMonth}K ({list.countQueriedThisMonth})
                                  </span>
                                </div>
                                <div className="nk-sale-data">
                                  <span className="sub-title">This Week</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumQueriedThisWeek}K ({list.countQueriedThisWeek})
                                  </span>
                                </div>
                                <div className="nk-sale-data">
                                  <span className="sub-title">Today</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumQueriedToday}K ({list.countQueriedToday})
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* .card */}
                      </div>
                      {/* .col */}
                      <div className="col-sm-6 col-lg-12 col-xxl-6">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div className="card-title-group align-start mb-2">
                              <div className="card-title">
                                <h6 className="title">Pending Vouchers</h6>
                              </div>
                            </div>
                            <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
                              <div className="nk-sale-data-group flex-md-nowrap g-4">
                                <div className="nk-sale-data">
                                  <span className="sub-title">Year To Date</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumPendingThisYear}K ({list.countPendingThisYear})
                                  </span>
                                </div>
                                <div className="nk-sale-data">
                                  <span className="sub-title">This Month</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumPendingThisMonth}K ({list.countPendingThisMonth})
                                  </span>
                                </div>
                                <div className="nk-sale-data">
                                  <span className="sub-title">This Week</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumPendingThisWeek}K ({list.countPendingThisWeek})
                                  </span>
                                </div>
                                <div className="nk-sale-data">
                                  <span className="sub-title">Today</span>
                                  <span className="amount" style={{fontStyle: 'bold', fontSize: 15}}>
                                  &#8358;{list.sumPendingToday}K ({list.countPendingToday})
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* .card */}
                      </div>
                      {/* .col */}
                    </div>
                    {/* .row */}
                  </div>
                  {/* .col */}
                </div>
                {/* .row */}
              </div>
              {/* .col */}
            </div>
              );
            })
          }
          </MainLayout>
        );
      
  }
}
